import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { MdEmail, MdPhone, MdLocationOn, MdAccessTime, MdBusiness } from "react-icons/md";
import { FaFacebook, FaTwitter, FaLinkedin, FaEnvelope } from "react-icons/fa";

const ContactPage = () => {
  return (
    <div className="App">
      <Header />

      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Ready to transform your sales? Get in touch with our team today</p>
        </div>
      </section>

      {/* Contact Main */}
      <section className="contact-main">
        <div className="container">
          <div className="contact-content">
            {/* Contact Information */}
            <div className="contact-info-detailed">
              <h2>Get In Touch</h2>
              <p>
                We're here to help you achieve your sales goals. Reach out to us
                using any of the methods below.
              </p>

              <div className="contact-methods">
                <div className="contact-method">
                  <div className="contact-icon">
                    <MdEmail />
                  </div>
                  <div className="contact-details">
                    <h4>Email</h4>
                    <p>info@hemsalesagencies.com</p>
                    <p>support@hemsalesagencies.com</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">
                    <MdPhone />
                  </div>
                  <div className="contact-details">
                    <h4>Phone</h4>
                    <p>+91 9321037171</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">
                    <MdLocationOn />
                  </div>
                  <div className="contact-details">
                    <h4>Address</h4>
                    <p>Shop No. G-27, Ground Floor, White Pearls, Adajan Surat, Gujarat – 395009</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">
                    <MdAccessTime />
                  </div>
                  <div className="contact-details">
                    <h4>Business Hours</h4>
                    <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
                    <p>Saturday: 10:00 AM - 4:00 PM</p>
                  </div>
                </div>
              </div>

              {/* Social Links */}
              {/* <div className="contact-social">
                <h4>Follow Us</h4>
                <div className="social-links">
                  <a href="#" className="social-link">
                    <FaFacebook />
                    <span>Facebook</span>
                  </a>
                  <a href="#" className="social-link">
                    <FaTwitter />
                    <span>Twitter</span>
                  </a>
                  <a href="#" className="social-link">
                    <FaLinkedin />
                    <span>LinkedIn</span>
                  </a>
                  <a href="#" className="social-link">
                    <FaEnvelope />
                    <span>Email</span>
                  </a>
                </div>
              </div> */}
            </div>

            {/* Contact Form */}
            {/* <div className="contact-form-detailed">
              <h2>Send Us a Message</h2>
              <form className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">First Name *</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">Last Name *</label>
                    <input type="text" id="lastName" name="lastName" required />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input type="email" id="email" name="email" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input type="tel" id="phone" name="phone" />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="company">Company Name</label>
                  <input type="text" id="company" name="company" />
                </div>

                <div className="form-group">
                  <label htmlFor="service">Service Interest *</label>
                  <select id="service" name="service" required>
                    <option value="">Select Service Interest</option>
                    <option value="analytics">
                      Sales Analytics & Reporting
                    </option>
                    <option value="leads">Lead Generation & Prospecting</option>
                    <option value="training">
                      Sales Training & Development
                    </option>
                    <option value="strategy">Growth Strategy & Planning</option>
                    <option value="consultation">General Consultation</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="budget">Budget Range</label>
                  <select id="budget" name="budget">
                    <option value="">Select Budget Range</option>
                    <option value="under-10k">Under $10,000</option>
                    <option value="10k-25k">$10,000 - $25,000</option>
                    <option value="25k-50k">$25,000 - $50,000</option>
                    <option value="50k-100k">$50,000 - $100,000</option>
                    <option value="over-100k">Over $100,000</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    placeholder="Tell us about your goals..."
                    required
                  ></textarea>
                </div>

                <div className="form-group checkbox-group">
                  <input type="checkbox" id="newsletter" name="newsletter" />
                  <label htmlFor="newsletter">
                    Subscribe to our newsletter for sales tips and insights
                  </label>
                </div>

                <button type="submit" className="btn btn-primary btn-large">
                  Send Message
                </button>
              </form>
            </div> */}
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="container">
          <h2>Visit Our Office</h2>
          <div className="map-placeholder">
            <div className="map-content">
              <div className="map-icon">
                <MdBusiness />
              </div>
              <h3>HEM SALES AGENCIES</h3>
              <p>Shop No. G-27, Ground Floor, White Pearls, Adajan</p>
              <p>Surat, Gujarat – 395009</p>
              <button className="btn btn-secondary">Get Directions</button>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>How long does a typical engagement last?</h3>
              <p>
                Most engagements range from 3-12 months, depending on the scope
                and complexity of your needs.
              </p>
            </div>
            <div className="faq-item">
              <h3>Do you work with small businesses?</h3>
              <p>
                Yes, we work with businesses of all sizes, from startups to
                Fortune 500 companies.
              </p>
            </div>
            <div className="faq-item">
              <h3>What industries do you serve?</h3>
              <p>
                We serve clients across various industries including technology,
                healthcare, finance, and manufacturing.
              </p>
            </div>
            <div className="faq-item">
              <h3>Do you offer remote consulting?</h3>
              <p>
                Yes, we offer both on-site and remote consulting services to
                accommodate your needs.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
